import React from 'react';
import { Alert } from 'antd';
import { InfoCircleOutlined } from '@ant-design/icons';
import { DefaultTheme } from 'styled-components';

// only few of them. Extend as needed.
type BorderStyle = 'dashed' | 'solid' | 'dotted' | 'none';

interface Props {
  text: string | React.ReactNode | React.ReactNode[];
  borderStyle?: BorderStyle;
  theme?: DefaultTheme;
  closable?: boolean;
  type?: 'info' | 'success' | 'warning' | 'error';
}

const InfoBox: React.FC<Props> = ({ text, type = 'info', ...props }) => (
  <Alert
    type={type}
    showIcon
    icon={<InfoCircleOutlined />}
    message={text}
    css={`
      align-items: flex-start;
      background-color: rgba(0, 0, 0, 0.02);
      border: ${({ borderStyle = 'solid', theme }: Props) =>
        `${borderStyle} 1px ${theme?.lightBlueGray}`};
      .ant-alert-message {
        color: rgba(0, 0, 0, 0.45);
      }
      .ant-alert-icon {
        color: rgba(0, 0, 0, 0.25);
        margin-top: 5px;
        margin-right: 10px;
      }
    `}
    {...props}
  />
);

export default InfoBox;
